import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { LocaleService } from '@oneComply/core/services/locale.service';

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = inject(LocaleService).current();

  return next(
    req.clone({
      setHeaders: {
        'X-Locale': locale,
      },
    })
  );
};

